module.exports = __webpack_public_path__ + "static/media/logo-reseller.02466019.jpeg";